<template>
    <div id="app">
        <logo class="logo"></logo>
        <socials></socials>
    </div>
</template>

<script>
	import logo from './components/logo/index.vue'
	import socials from './components/socials/index.vue'

	export default {
		name: 'app',
		components: {
			logo,
			socials
		}
	}
</script>

<style rel="stylesheet/stylus" lang="stylus">
    @import "./assets/main.styl"

    #app {
        width 100%
        height 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
    }
    .logo {
        width 15rem
        height @width
        margin-bottom 4rem
        color #53a6d2
        @media (max-width: 600px) {
            width 10rem
            height @width
            margin-bottom 1rem
        }
    }
</style>

